export class Funcionario{
    id = 0;
    nome = '';
}